module.exports = __webpack_public_path__ + "img/child.79b1823a.svg";